import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  hymnListOpen: boolean = true;
  hymnListToggleSubject = new BehaviorSubject<boolean>(true);
  sidenavState$ = this.hymnListToggleSubject.asObservable();
  settingsOpened: boolean = false;

  constructor() { }

  public openList() {
    this.hymnListOpen = true;
    return this.hymnListToggleSubject.next(true);
  }

  public closeList() {
    this.hymnListOpen = false;
    return this.hymnListToggleSubject.next(false);
  }

  public toggleList(): void {
    this.hymnListOpen = !this.hymnListOpen;
    this.hymnListToggleSubject.next(!this.hymnListToggleSubject.value);
  }
}
